module.exports = __webpack_public_path__ + "assets/img/ca63e79f1b40bed1eaf0b7ecd518552a.png";